






















































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IIDNamePairWithColor } from '@/types/data-objects/global'
import {
  IJobAssigneeMandate,
  IPersonWithEmail,
  IStatusForSelection,
} from '@/api/types/response.types'
import { IJobInfo } from '@/types/data-objects/items'

/* API */

export default Vue.extend({
  name: 'SelectButtonWithAssigneeMandates',
  props: {
    value: {
      type: [String, Number, Object, Array],
      default: null,
    },
    statuses: {
      type: Array as () => IStatusForSelection[],
      default: (): IStatusForSelection[] => [],
    },
    jobInfo: {
      type: Object as () => IJobInfo,
      required: true,
    },
    size: {
      type: String,
      default: 'small',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpen: false,
      internalValue: 0,
    }
  },

  computed: {
    // There could be a case where the current assignee IS NOT the mandated assignee
    // (e.g. job rule updated, jobs were turned off before and it was a different assignee).
    // So, only use the assignee mandate if a new status has been selected.
    selectedStatusAssignee(): IPersonWithEmail {
      if (this.selectedStatus.id === this.jobInfo.currentStatus.id) {
        return this.jobInfo.currentAssignee
      }
      return this.getAssigneeMandatedForStatus(this.selectedStatus)
    },
    selectedStatus(): IIDNamePairWithColor {
      if (!this.internalValue) {
        return this.statuses[0]
      }
      return this.statuses.find(o => o.id === this.internalValue)
    },
    selectedColor(): string {
      return this.getColor(this.selectedStatus)
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.internalValue = newVal
      },
    },
  },

  methods: {
    getAssigneeMandatedForStatus(
      status: IStatusForSelection,
    ): IPersonWithEmail {
      const mandate = this.getMandateForStatus(status)
      return mandate
        ? this.jobInfo.jobAppointees.find(ja => ja.job.id === mandate.jobID)
            .appointee
        : null
    },

    getMandateForStatus(status: IStatusForSelection): IJobAssigneeMandate {
      return this.jobInfo.assigneeMandates.find(am => am.statusID === status.id)
    },

    getJobNameMandatedForStatus(status: IStatusForSelection): string {
      const mandate = this.getMandateForStatus(status)
      return mandate
        ? this.jobInfo.jobAppointees.find(ja => ja.job.id === mandate.jobID).job
            .name
        : ''
    },

    getColor(value: IIDNamePairWithColor) {
      return value ? value.color : 'grey'
    },

    handleSelect(value: number) {
      if (this.internalValue === value) {
        return
      }
      this.internalValue = value
      this.$emit('input', value)
      // @ts-ignore
      this.$refs.selectButtonDropdown.handleClose()
    },
    isSelected(item: any) {
      if (this.selectedStatus) {
        return item.id === this.selectedStatus.id
      }
      return false
    },
  },
})
